module.exports = __webpack_public_path__ + "static/media/darktea.6afe4344.jpg";